import React from "react";
import { StyleSheet, View } from "react-native";
import { useTheme } from "../AHTheme/AHTheme";
import { useLayoutContext } from "../LayoutProvider";
import { AHText } from "../Text";
import { AHIcon } from "../AHIcon";

const style = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  text: {
    textAlign: "center",
  },
});
export const AHWidgetNoData = () => {
  const theme = useTheme();
  const size = useLayoutContext().circle.medium;
  return (
    <View style={[style.container]}>
      <View style={{ alignItems: "center", flexDirection: "column" }}>
        <AHText type="subtitle" style={[style.text]} numberOfLines={1}>
          No Data
        </AHText>
        <AHIcon type="activity" customColor={theme.washedText} forceSize={size} />
      </View>
    </View>
  );
};
